module.exports = __webpack_public_path__ + "img/bg-flow.fbfd6521.fbfd6521.png";